import { all, fork } from 'redux-saga/effects';

import propertySaga from './property/saga';
export default function* rootSaga() {
  yield all([fork(propertySaga)]);
}
